const translations = {
    notSet: 'Not set',
    renewalDate: 'Renewal Date',
    seats: 'Seats',
    subscription: 'Subscription',
    summary: 'Summary',
    totalSeats: 'Total Seats: {{seats}}'
};

export default translations;
